import {ActionPlansListFilter} from './ActionPlansListFilter'

const ActionPlansListHeader = () => {
  return (
    <div className='d-flex flex-column flex-grow-1'>
      <ActionPlansListFilter />

      <div className='separator border-gray-200'></div>
    </div>
  )
}

export {ActionPlansListHeader}
